import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import Select from "react-select";
import FileUploader from "../../../components/ImageUploader";
import * as Yup from "yup";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";

const PostWhatsNewForthcoming = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialFormData = {
    Name: "",
    Date: moment(new Date()).format("DD-MMM-YYYY"),
    Category_169: null,
    Description: "",
    Image: null,
  };

  const pdfOnlyCategoryLabels = ["IT Tips", "Weekly Dose AI", "Admin", "SnowFlake","Power Bytes","DS Pulse"];

  useEffect(() => {
    dispatch(updateNavbarHeading("Broadcast"));
    fetchGetData();
  }, []);

  const [categoryOption, setCategoryOptions] = useState([]);
  const [Image, setImage] = useState("");
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData",formData);
  
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [attachFile, setAttachFile] = useState("");
  const [isPdfOnly, setIsPdfOnly] = useState(false);

  
  useEffect(() => {
    if (formData.Category_169) {
      // Find the selected category by value
      const selectedCategory = categoryOption.find(
        (option) => option.value === formData.Category_169
      );
      
      // Check if the label is in the pdfOnlyCategoryLabels array
      setIsPdfOnly(selectedCategory && pdfOnlyCategoryLabels.includes(selectedCategory.label));
    } else {
      setIsPdfOnly(false);
    }
  }, [formData.Category_169, categoryOption]);

  const getSchema = () => {
    return Yup.object().shape({
      Name: Yup.string().required("Title is required"),
      Description: Yup.string().required("Description is required"),
      Date: Yup.date()
        .typeError("Date is required")
        .nullable()
        .required("Date is required"),
      Category_169: Yup.number()
        .typeError("Category is required")
        .required("Category is required"),
      Image: Yup.mixed()
        .required("Attachment is required")
        .test(
          "fileType",
          isPdfOnly
            ? "Only PDF files are allowed for this category"
            : "Only JPEG, JPG, PNG and PDF files are allowed",
          (value) => {
            if (!value) return false;

            if (isPdfOnly) {
              return value.type === "application/pdf";
            } else {
              return [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "application/pdf",
              ].includes(value.type);
            }
          }
        )
        .test(
          "fileSize",
          "File size should not exceed 2MB",
          (value) => value && value.size <= 2 * 1024 * 1024
        ),
    });
  };

  const fetchGetData = async () => {
    try {
      let response = await GetServiceCaller(`${API_URL}newsletter`);
      if (response?.status === 200) {
        setPageLoading(false);
        const cleanedData = response?.data?.data;
        const catOpt = cleanedData?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setCategoryOptions(catOpt);
      }
    } catch (error) {
      console.error("Fetching Error", error);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    await validateField(name, value);
  };

  const handleSelect = async (selectedOption, { name }) => {
    const value = selectedOption ? selectedOption.value : null;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prev) => ({ ...prev, Category_169: "" }));
  };

  const handleDateChange = (date, name) => {
    setFormData((prevData) => ({ ...prevData, [name]: date }));
    // validateField(name, date);
  };

  const validateField = async (fieldName, value) => {
    try {
      const currentSchema = getSchema();
      await currentSchema.validateAt(fieldName, { [fieldName]: value });
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
      return true;
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
      return false;
    }
  };

  const validateForm = async () => {
    try {
      const currentSchema = getSchema();
      await currentSchema.validate(formData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      setErrors(newErrors);
      return false;
    }
  };

  const handleFile = (file) => {
    if (!file) {
      setErrors((prev) => ({
        ...prev,
        Image: "Please select a file",
      }));
      return;
    }

    // Check file type based on category
    let validTypes;
    if (isPdfOnly) {
      validTypes = ["application/pdf"];
    } else {
      validTypes = ["image/jpeg", "image/png", "image/jpg"];
    }

    if (!validTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        Image: isPdfOnly
          ? "Only PDF files are allowed for this category"
          : "Only JPEG, JPG and PNG are allowed",
      }));
      return;
    }

    // Check file size (e.g., 2MB max)
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      setErrors((prev) => ({
        ...prev,
        Image: "File size should not exceed 2MB",
      }));
      return;
    }

    // If validations pass
    setImage(file.name);
    setFormData((prev) => ({ ...prev, Image: file }));
    setAttachFile(file);
    setErrors((prev) => ({ ...prev, Image: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const isValid = await validateForm();
    if (!isValid) {
      setLoading(false);
      return;
    }

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}newsletter`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (error) {
      console.error("Post Error", error);
      toast.error("Failed to submit data");
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p className="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner className="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="Container m-2 m-sm-0">
        <form id="formOne" className="rounded mt-2 bg-white">
          <div className="mx-3">
            <div className="row">
              <div className="col-md-3">
                <label className="form-label">
                  Title<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="Name"
                  placeholder="Title"
                  className={`form-control mb-0 ${
                    errors.Name ? "is-invalid" : ""
                  }`}
                  onChange={handleChange}
                  value={formData.Name}
                />
                {errors.Name && (
                  <div className="invalid-feedback">{errors.Name}</div>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Category<span className="text-danger">*</span>
                </label>
                <Select
                  options={categoryOption}
                  name="Category_169"
                  onChange={handleSelect}
                  className={errors.Category_169 ? "is-invalid" : ""}
                  classNamePrefix="select"
                />
                {errors.Category_169 && (
                  <div className="invalid-feedback">{errors.Category_169}</div>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Date<span className="text-danger">*</span>
                </label>
                <CustomDatePicker
                  placeholderText="DD-MMM-YYYY"
                  name="Date"
                  value={formData.Date}
                  handleChange={handleChange}
                  className={errors.Date ? "is-invalid" : ""}
                />
                {errors?.Date && (
                  <div className="invalid-feedback d-block">{errors.Date}</div>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Description<span className="text-danger">*</span>
                </label>
                <textarea
                  name="Description"
                  className={`form-control mb-0 ${
                    errors.Description ? "is-invalid" : ""
                  }`}
                  value={formData.Description}
                  onChange={handleChange}
                  placeholder={isPdfOnly ? "Description must be at least 200 characters." : ""}
                />
                {errors.Description && (
                  <div className="invalid-feedback">{errors.Description}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="d-flex mt-4">
                  <div>
                    <label className="form-label">
                      Attachment<span className="text-danger">*</span>
                    </label>
                    <div>
                      <FileUploader
                        title="Attach"
                        handleFile={handleFile}
                        accept={isPdfOnly ? ".pdf" : ".jpg,.jpeg,.png"}
                      />
                    </div>
                    {Image && <p className="m-2">{Image}</p>}
                    {errors.Image && (
                      <div className="text-danger small">{errors.Image}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <p className="attach_msg">
              {isPdfOnly
                ? "Please upload only PDF files for this category."
                : "Please upload an image in JPEG, JPG or PNG format."}
            </p>
            <div className="mt-2 d-flex justify-content-end">
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() => navigate("/")}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="custom-btn"
                onClick={handleSubmit}
              >
                {loading ? <FaSpinner className="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

export default PostWhatsNewForthcoming;